<!-- nnkitodo [v2later card] voir si on peut mutualiser avec card picto corner -->
<div class="card-v2 card--picto-corner">
  <div class="card-header">
    <app-round-cover-image
      (click)="modalService.openModalStudentProfile(testimony.author.id)"
      [src]="testimony.author.picture"
      [size]="58"
      class="cursor-pointer mr-6 shrink-0"
    ></app-round-cover-image>

    <div class="card-header-content">
      <div class="card-title">
        <p>{{ testimony.author.username }}</p>
      </div>

      <div class="card-theme">
        <p>{{ testimony.author.university?.name }}</p>
      </div>
    </div>

    <div class="card-infos">
      <div class="card-info" *ngIf="testimony.ecnRank">
        <svg-icon
          class="info-icon text-yellow-one"
          src="assets/images/svg-icons/icon-star-fill.svg"
          [svgStyle]="{ 'width.px': '14' }"
        ></svg-icon>
        <span class="info-txt">{{ testimony.ecnRank }}</span>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div
      class="text-theme-gray-nines text-13 leading-loose italic"
      [ngClass]="{ 'line-clamp-none': isFullyDisplayed, 'line-clamp-6': !isFullyDisplayed }"
    >
      <p [innerHTML]="testimony.content" #testimonyMessage></p>
    </div>
  </div>

  <div class="card-footer" *ngIf="showToggle">
    <div class="card-actions ml-auto">
      <button
        matRipple
        [matRippleCentered]="false"
        [matRippleUnbounded]="true"
        [matRippleRadius]="50"
        (click)="isFullyDisplayed = !isFullyDisplayed"
        class="btn-nnki btn-nnki-action"
      >
        <svg-icon
          src="assets/images/svg-icons/icon-arrow-down.svg"
          [svgStyle]="{ 'width.px': '13' }"
          [ngClass]="{ 'rotate-180': isFullyDisplayed }"
        ></svg-icon>
      </button>
    </div>
  </div>
</div>
